module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#DADADA;} </style><g><circle class=\"st0\" cx=\"8\" cy=\"8\" r=\"7.5\"></circle><path class=\"st1\" d=\"M8,1c3.9,0,7,3.1,7,7s-3.1,7-7,7s-7-3.1-7-7S4.1,1,8,1 M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0 L8,0z\"></path></g></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/radio_button_default.svg
 ** module id = 1056
 ** module chunks = 0
 **/